module.exports = __webpack_public_path__ + "static/media/gioweb2_logo_white.c608e88e.svg";